import _ from "lodash";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { dependentsServices } from "../../../../api/services/dependentsServices";

import { setAlldependentslist } from "../../../../infra/aggregates/myProfile/DependentsAggregates/dependentslistSlice";

import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import AddDependentsPresenter from "./AddDependentsPresenter";
import DTOAddDependents from "./DTOAddDependents";
interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  depdDocumentsList: any;
  mainModel: any;
  trans?: any;
}
const AddDependentsController = ({
  isModalOpen,
  closeModal,
  depdDocumentsList,
  mainModel,
  trans,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.authSlice);
  const companyId = useAppSelector((state) => state.authSlice.company_id);
  const [EmpDocTypes, setEmpDocTypes] = useState<[]>([]);
  const [countries, setCountries] = useState<[]>([]);
  const dispatch = useAppDispatch();

  async function callBack(data: []) {
    setCountries(data);
  }
  async function callBackEmptypes(data: []) {
    setEmpDocTypes(data);
  }
  const getData = (data: any) => {
    addingDependentsDocs(data);
  };
  const storeDepDocs: any = useAppSelector(
    (state) => state.dependentslistSlice.dependentslist
  );
  async function addingDependentsDocs(addEmpDocs: any) {
    if (selector) {
      const empId: any = selector.emp_id;

      const formData: any = new FormData();

      formData.append("empId", empId);
      formData.append("dependentId", depdDocumentsList?.id);
      formData.append("document_type_id", addEmpDocs.documentTypeId);
      formData.append("issue_country", addEmpDocs.countryName);
      formData.append("issue_date", addEmpDocs.issueDate);
      formData.append("validity_date", addEmpDocs.expiredDate);
      formData.append("identifier_number", addEmpDocs.identifierNo);
      formData.append("remarks", addEmpDocs.remarks);
      if (addEmpDocs.newattachement) {
        formData.append("documents[]", addEmpDocs.file);
      }
      formData.append("locale", localStorage.getItem("emplang"));

      await dependentsServices
        .addDependentDocs(formData)
        .then((response: any) => {
          if (response.response == "success") {
            dispatch(setAlldependentslist(response.data));
            toast.success(trans("Added Successfully"));
            mainModel(false);
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data?.data);
        });
    }
  }
  return (
    <>
      <DTOAddDependents
        setAllCountries={callBack}
        setAllEmpDocsType={callBackEmptypes}
      />
      <AddDependentsPresenter
        callBackGetData={getData}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        allEmpDocTypes={EmpDocTypes}
        allCountires={countries}
        trans={trans}
      />
    </>
  );
};
export default AddDependentsController;
